module.exports = __webpack_public_path__ + "img/frame.7bb565f7.webp";